<div class="title">
  {{ title() }}
</div>

<div class="value">
  {{ value() }}
</div>
